export default "__VITE_ASSET__4bb5278c__"